import React, { useEffect, useLayoutEffect, useState } from 'react'
import styles from './Style.module.css'
import { BtnClose } from '../Buttons/BtnClose/BtnClose'
import { BtnLink } from '../Buttons/BtnLink'

export const Snakbar = ({
  text, 
  type,
  active, 
  varient, 
  customClass = '',
  hasButton = false,
  onClose,
  hasLink = false,
  linkText = '',
  linkClick = () => {}
}) => {
  const [isActive, setIsActive] = useState(!!active)
  const [footerHeight, setFooterHeight] = useState(0)

  useLayoutEffect(() => {
    if (!isActive) return

    // Only active footers reserve space; their rendered height can vary by page.
    let footers = []
    const measure = () => {
      const height = footers.reduce((maximum, footer) => {
        const style = window.getComputedStyle(footer)
        if (style.display === 'none' || style.visibility === 'hidden') return maximum
        return Math.max(maximum, footer.offsetHeight + (parseFloat(style.bottom) || 0))
      }, 0)
      setFooterHeight(height)
    }
    // setState inside the ResizeObserver callback re-renders within the same
    // observation cycle ("ResizeObserver loop completed with undelivered
    // notifications"); measure on the next frame instead.
    let frame = null
    const scheduleMeasure = () => {
      if (frame !== null) return
      frame = window.requestAnimationFrame(() => {
        frame = null
        measure()
      })
    }
    const resizeObserver = new ResizeObserver(scheduleMeasure)
    const observeFooters = () => {
      resizeObserver.disconnect()
      footers = Array.from(document.querySelectorAll('[data-snackbar-footer="true"]'))
      footers.forEach((footer) => resizeObserver.observe(footer))
      scheduleMeasure()
    }
    const mutationObserver = new MutationObserver(observeFooters)
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-snackbar-footer'],
    })
    observeFooters()
    window.addEventListener('resize', scheduleMeasure)
    return () => {
      resizeObserver.disconnect()
      mutationObserver.disconnect()
      window.removeEventListener('resize', scheduleMeasure)
      if (frame !== null) window.cancelAnimationFrame(frame)
    }
  }, [isActive])

  useEffect(() => {
    setIsActive(!!active)
  }, [active])

  const handleClose = (e) => {
    e?.preventDefault?.()
    e?.stopPropagation?.()
    setIsActive(false)
    onClose?.()
  }

  return (
    <div varient={varient}
    style={{ '--SnackbarFooterHeight': `${footerHeight}px` }}
    className={`
    ${styles.snackbar} 
    ${hasButton ? styles.dismissible : ''}
    ${type === 'error' ? styles.error : ''}
    ${isActive ? styles.show : ''} 
    ${customClass}
    `}>
      <div className={styles.text}>{text}</div>
      {hasLink && (
        <BtnLink
          label={linkText}
          handleClick={linkClick}
          customClass={styles.link}
          type="button"
          disabled={false}
          title={linkText}
        />
      )}
      {hasButton && (
        <BtnClose
          title="Close"
          handleClick={handleClose}
          customClass={styles.btnClose}
          iconSize={20}
          iconColor="#fff"
        />
      )}
    </div>
  )
}
